module.exports = __webpack_public_path__ + "static/media/NotAvailableImg.d670ef9a.png";